import { render, staticRenderFns } from "./VisorArchivo.vue?vue&type=template&id=51c2e593&scoped=true"
import script from "./VisorArchivo.vue?vue&type=script&lang=js"
export * from "./VisorArchivo.vue?vue&type=script&lang=js"
import style0 from "./VisorArchivo.vue?vue&type=style&index=0&id=51c2e593&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c2e593",
  null
  
)

export default component.exports